@if (hasAnyPermission) {
  <button
    [matMenuTriggerFor]="batchActionsMenu"
    mat-icon-button
    matTooltip="Batch actions"
    color="primary"
    matTooltipPosition="right"
    class="mat-elevation-z0"
    >
    <mat-icon>folder</mat-icon>
  </button>
}
<mat-menu #batchActionsMenu="matMenu">
  @if (sectionVisible['PREP']) {
    <div mat-subheader>PREP</div>
  }
  <app-upload-products-action
    (actionComplete)="actionComplete.emit()"
    (visibilityDeclared)="onChildVisibility('PREP', $event)"
  ></app-upload-products-action>
  <app-add-products-action
    (actionComplete)="actionComplete.emit()"
    (visibilityDeclared)="onChildVisibility('PREP', $event)"
  ></app-add-products-action>

  @if (sectionVisible['SHOOTING']) {
    <div mat-subheader>SHOOTING</div>
  }
  <app-transfer-mastersuite-action
    [products]="products"
    [masterSuites]="masterSuites"
    (actionComplete)="actionComplete.emit()"
    (visibilityDeclared)="onChildVisibility('SHOOTING', $event)"
  ></app-transfer-mastersuite-action>
</mat-menu>
